import styled from '@emotion/styled';
import { H3 } from 'ds/components/typography';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.neutrals.grey10};
  padding: ${({ theme }) => theme.spacing(2)} 0;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    flex-wrap: wrap;
    justify-content: center;
  `}
  & > div {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
    ${({ theme }) => theme.media.showAt({ at: 1 })`
      flex-wrap: wrap;
      justify-content: center;
    `}
  }
`;

export const Title = styled(H3)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  padding-left: ${({ theme }) => theme.spacing(1)};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 100%;
    padding-left: 0;
    text-align: center;
    padding-bottom: ${theme.spacing(1)};
  `}
`;

export const Social = styled.a<{ skipFill?: boolean }>`
  width: 56px;
  height: 56px;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  flex-shrink: 0;
  svg {
    path {
      fill: ${({ theme, skipFill }) => skipFill ? 'inherit' : theme.colors.brand.main};
    }
  }
`;
